import '../../../../neb-lit-components/src/components/tables/neb-table-my-statements';
import '../../../../neb-lit-components/src/components/neb-pagination';
import { LitElement, html, css } from 'lit';

import { getOnlinePatientStatements } from '../../../../../src/api-clients/booking/booking-patient';
import { getStatementFromS3 } from '../../../../../src/api-clients/booking/booking-statement';
import {
  CSS_SPACING,
  CSS_COLOR_HIGHLIGHT,
  CSS_FONT_SIZE_HEADER,
  CSS_FONT_WEIGHT_BOLD,
} from '../../../../../src/styles';
import { baseStyles } from '../../../../neb-styles/neb-styles';
import { printPdf } from '../../../../neb-utils/neb-pdf-print-util';
import { FetchService } from '../../../../neb-utils/services/fetch';
import { MODE } from '../../../../neb-utils/table';

export const ELEMENTS = {
  table: { id: 'table' },
  pagination: { id: 'pagination' },
};

const LIMIT = 5;

class NebMyStatements extends LitElement {
  static get properties() {
    return {
      layout: {
        type: String,
        reflect: true,
      },
      linkedPatient: Object,
      __statements: Array,
      __currentPage: Number,
      __pageCount: Number,
    };
  }

  static get styles() {
    return [
      baseStyles,
      css`
        .pagination {
          flex-direction: row-reverse;
          padding-top: ${CSS_SPACING};
          padding-right: 10px;
          margin-bottom: ${CSS_SPACING};
        }

        .title {
          color: ${CSS_COLOR_HIGHLIGHT};
          font-size: ${CSS_FONT_SIZE_HEADER};
          font-weight: ${CSS_FONT_WEIGHT_BOLD};
          padding-top: 30px;
        }

        :host([layout='small']) .title {
          padding: 30px ${CSS_SPACING} 0px;
        }

        .table {
          padding-top: ${CSS_SPACING};
        }
      `,
    ];
  }

  constructor() {
    super();

    this.__initState();
    this.__initHandlers();
    this.__initServices();
  }

  __initState() {
    this.linkedPatient = {};
    this.__statements = [];
    this.__currentPage = 0;
    this.__pageCount = null;
  }

  __initHandlers() {
    this.__handlers = {
      viewStatement: (_, item) => printPdf(getStatementFromS3(item.id)),
      pageChanged: pageIndex => {
        this.__statementsFetchService.setQuery('optOutLoadingIndicator', true);
        this.__statementsFetchService.setPageIndex(pageIndex);
      },
    };
  }

  __initServices() {
    this.__statementsFetchService = new FetchService(
      {
        onChange: ({ pageItems, pageCount, pageIndex }) => {
          this.__statements = pageItems;
          this.__pageCount = pageCount;
          this.__currentPage = pageIndex;
        },
      },
      getOnlinePatientStatements,
      {
        pageSize: LIMIT,
        hideInactive: false,
      },
    );
  }

  updated(changedProps) {
    if (changedProps.has('linkedPatient') && this.linkedPatient.patientId) {
      this.__statementsFetchService.setQuery(
        'patientId',
        this.linkedPatient.patientId,
      );

      this.__statementsFetchService.fetch();
    }
  }

  __renderTable() {
    return this.__pageCount !== null
      ? html`
          <neb-table-my-statements
            id="${ELEMENTS.table.id}"
            name="my-statements-table"
            class="table"
            emptyMessage="You have no statements at this time."
            .layout="${this.layout}"
            .mode="${this.layout === 'small' ? MODE.DETAIL : MODE.NONE}"
            .model="${this.__statements}"
            .onView="${this.__handlers.viewStatement}"
            .onSelectRow="${this.__handlers.viewStatement}"
          ></neb-table-my-statements>
        `
      : '';
  }

  __renderPagination() {
    return this.__pageCount > 1
      ? html`
          <neb-pagination
            id="${ELEMENTS.pagination.id}"
            class="pagination"
            .pageCount="${this.__pageCount}"
            .currentPage="${this.__currentPage}"
            .onPageChanged="${this.__handlers.pageChanged}"
            .layout="${this.layout}"
          ></neb-pagination>
        `
      : '';
  }

  render() {
    return html`
      <div class="title">Statements</div>
      ${this.__renderTable()} ${this.__renderPagination()}
    `;
  }
}

customElements.define('neb-my-statements', NebMyStatements);
